import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import {
  EmailSettingsParams,
  USER_EMAIL_SETTINGS_KEY,
  updateEmailSettings,
} from '@utils/backend-api/settings';
import { SuccessResponse } from '@utils/interfaces';

export default function useEmailSettingsUpdate() {
  const queryClient = useQueryClient();
  const { mutate, data, isLoading, isError } = useMutation(
    (params: EmailSettingsParams) => updateEmailSettings(params),
    {
      onSuccess: (data: SuccessResponse) => {
        toast.success(data.message);
        queryClient.invalidateQueries(USER_EMAIL_SETTINGS_KEY);
      },
      onError: (error: { message: string }) => {
        toast.error(error.message);
      },
    }
  );
  return { mutate, data, isLoading, isError };
}
